import { type FC } from 'react'
import { getDefaultRegistry } from '@rjsf/core'
import { type WidgetProps } from '@rjsf/utils'
import { NumberWidget } from './NumberWidget'

const { TextWidget: DefaultTextWidget } = getDefaultRegistry().widgets

export const TextWidget: FC<WidgetProps> = (props) =>
  props.schema.type === 'number' || props.schema.type === 'integer' ? <NumberWidget {...props} /> : <DefaultTextWidget {...props} />
